import PropTypes from 'prop-types';
import React from 'react';

import CustomCol from '../../bootstrap/CustomCol';

const LeftSidebarLayout = ({
  sidebar,
  content,
  sidebarPlaceHolder,
  contentPlaceHolder,
}) => {
  const renderCustomCol = (node, sizes, placeholder = null) => {
    return <CustomCol {...sizes}>{node || placeholder}</CustomCol>;
  };

  return (
    <>
      {renderCustomCol(
        sidebar,
        {
          md: 12,
          lg: 3,
          className: 'SidebarLayout__left',
        },
        sidebarPlaceHolder
      )}
      {renderCustomCol(
        content,
        {
          md: 12,
          lg: 9,
          className: 'SidebarLayout__right',
        },
        contentPlaceHolder
      )}
    </>
  );
};

LeftSidebarLayout.propTypes = {
  sidebar: PropTypes.node,
  content: PropTypes.node,
  className: PropTypes.string,
  sidebarPlaceHolder: PropTypes.node,
  contentPlaceHolder: PropTypes.node,
};

export default LeftSidebarLayout;
